export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  icon: string;
  content: CategoryContent[];
}

export interface CategoryContent {
  id: string;
  title: string;
  description: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'sports',
    name: '体育赛事',
    description: '汇聚全球顶级体育赛事资讯与精彩内容',
    icon: 'ri-football-line',
    content: [
      { id: 'sp-1', title: '欧洲顶级联赛激战正酣', description: '各大豪门纷纷在联赛中展现统治力，本轮焦点战役不容错过。', imageSeq: 'sports-card-01' },
      { id: 'sp-2', title: 'NBA季后赛精彩对决', description: '东西部强强对话，谁能最终问鼎总冠军？', imageSeq: 'sports-card-02' },
      { id: 'sp-3', title: '网球大满贯赛事回顾', description: '年度大满贯赛事精彩瞬间回顾，传奇对决令人难忘。', imageSeq: 'sports-card-03' },
      { id: 'sp-4', title: 'F1赛车速度与激情', description: '新赛季F1赛事全面提速，各车队技术革新引人注目。', imageSeq: 'sports-card-04' },
      { id: 'sp-5', title: '电子竞技全球热潮', description: '电竞赛事观赛人数再创新高，产业链持续高速增长。', imageSeq: 'sports-card-05' },
      { id: 'sp-6', title: '奥运会倒计时启动', description: '下一届奥运会各项筹备工作全面展开，全民期待盛会到来。', imageSeq: 'sports-card-06' },
    ],
  },
  {
    id: 'cat-2',
    slug: 'entertainment',
    name: '精彩娱乐',
    description: '丰富多彩的娱乐内容，尽享欢乐时光',
    icon: 'ri-movie-line',
    content: [
      { id: 'en-1', title: '年度热门影视盘点', description: '今年最受欢迎的影视作品大盘点，你错过了哪些好片？', imageSeq: 'entertainment-card-01' },
      { id: 'en-2', title: '综艺节目收视排行', description: '各大卫视王牌综艺节目收视率排行揭晓。', imageSeq: 'entertainment-card-02' },
      { id: 'en-3', title: '音乐盛典精彩瞬间', description: '年度音乐颁奖典礼落下帷幕，谁是你心中的最佳歌手？', imageSeq: 'entertainment-card-03' },
      { id: 'en-4', title: '游戏新作推荐', description: '本月最受期待的游戏新作，品质大作不容错过。', imageSeq: 'entertainment-card-04' },
      { id: 'en-5', title: '动漫新番速递', description: '新一季动漫作品全面上线，热门续作与原创佳作齐飞。', imageSeq: 'entertainment-card-05' },
      { id: 'en-6', title: '美食文化探索', description: '从街头小吃到米其林餐厅，探索全球美食文化的魅力。', imageSeq: 'entertainment-card-06' },
    ],
  },
  {
    id: 'cat-3',
    slug: 'lifestyle',
    name: '品质生活',
    description: '关注生活品质，发现美好生活方式的无限可能',
    icon: 'ri-heart-line',
    content: [
      { id: 'lf-1', title: '都市生活新方式', description: '当代都市人的新生活理念，如何在快节奏中找到平衡。', imageSeq: 'lifestyle-card-01' },
      { id: 'lf-2', title: '时尚潮流趋势', description: '本季最流行的时尚元素解读，打造属于你的风格穿搭。', imageSeq: 'lifestyle-card-02' },
      { id: 'lf-3', title: '家居设计灵感', description: '简约而不简单，现代家居设计新趋势分享。', imageSeq: 'lifestyle-card-03' },
      { id: 'lf-4', title: '健康养生指南', description: '科学养生方法全攻略，让健康成为生活的底色。', imageSeq: 'lifestyle-card-04' },
      { id: 'lf-5', title: '旅行目的地推荐', description: '年度最值得去的旅行目的地，开启你的精彩旅程。', imageSeq: 'lifestyle-card-05' },
      { id: 'lf-6', title: '科技改变生活', description: '最新科技产品如何改变我们的日常生活方式。', imageSeq: 'lifestyle-card-06' },
    ],
  },
  {
    id: 'cat-4',
    slug: 'finance',
    name: '财经资讯',
    description: '提供专业财经资讯，洞察市场趋势与投资先机',
    icon: 'ri-line-chart-line',
    content: [
      { id: 'fi-1', title: '全球经济趋势分析', description: '权威机构发布最新全球经济展望，把握宏观趋势。', imageSeq: 'finance-card-01' },
      { id: 'fi-2', title: '数字货币前沿', description: '区块链技术的最新应用与发展前景深度解读。', imageSeq: 'finance-card-02' },
      { id: 'fi-3', title: '投资理财策略', description: '资深分析师分享长期稳健的投资理财方法论。', imageSeq: 'finance-card-03' },
      { id: 'fi-4', title: '企业财报解读', description: '头部企业最新季度财报全面解读，洞察行业风向标。', imageSeq: 'finance-card-04' },
      { id: 'fi-5', title: '创业融资动态', description: '创投圈最新融资事件汇总，风口赛道全面解读。', imageSeq: 'finance-card-05' },
      { id: 'fi-6', title: '保险规划指南', description: '家庭保险配置最优方案，为您的财富保驾护航。', imageSeq: 'finance-card-06' },
    ],
  },
];

export const categorySlugMap: Record<string, Category> = {};
categories.forEach((cat) => {
  categorySlugMap[cat.slug] = cat;
});